
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import {
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogFooter, 
  DialogHeader, 
  DialogTitle
} from "@/components/ui/dialog";
import { DialogFixUtil } from "@/components/ui/dialog-fix-util";

interface DeletePropertyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
  isPending: boolean;
}

export const DeletePropertyDialog: React.FC<DeletePropertyDialogProps> = ({
  open,
  onOpenChange,
  onDelete,
  isPending
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogFixUtil open={open} />
      <DialogContent 
        onPointerDownOutside={(e) => {
          // Prevent closing when interacting with popover content
          if (e.target instanceof Node) {
            const target = e.target as HTMLElement;
            if (target.closest('[data-radix-popover-content]')) {
              e.preventDefault();
            }
          }
        }}
        onInteractOutside={(e) => {
          // Additional protection against unwanted closing
          const target = e.target as HTMLElement;
          if (target.closest('[data-popover-container]') || 
              target.closest('.tippy-box')) {
            e.preventDefault();
          }
        }}
        onClick={(e) => {
          // Stop propagation to prevent underlying interactions
          e.stopPropagation();
        }}
      >
        <DialogHeader>
          <DialogTitle>Delete Property</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this property? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={onDelete}
            disabled={isPending}
          >
            {isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              "Delete Property"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
